module.exports = __webpack_public_path__ + "img/shoper.c191433e.png";